
import { ref } from 'vue';
export default {
	props: {
		isDark: {
			type: Boolean,
			required: false,
			default: false,
		},
		gnbShow: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	setup() {
		let isMenuOpen = ref(false);
		const menuArr = [
			{ title: '회사소개', path: '/about' },
			{
				title: '헬스케어 플랫폼',
				path: '/health',
			},
			{ title: '모바일 가상화', path: '/jvmp' },
			{ title: '소식', path: '/news' },
			// { title: '문의하기', path: '/contact' },
		];
		return {
			isMenuOpen,
			menuArr,
		};
	},
};
